import { format, formatDistanceToNow, isValid, parseISO } from 'date-fns';
import { BillingConnectionData } from '../../../services/billing-integration/response/BillingConnectionResponse';

export const scopeLabel = (scopeType: BillingConnectionData['scope_type']): string =>
    scopeType === 'company' ? 'B2B (company)' : 'B2C (property)';

const toDate = (value: string): Date | null => {
    const date = parseISO(value);
    return isValid(date) ? date : null;
};

/** Local date-time, or a placeholder when the value is empty. */
export const formatDateTime = (value: string | null | undefined, placeholder = 'Never'): string => {
    if (!value) return placeholder;
    const date = toDate(value);
    return date ? format(date, 'dd MMM yyyy HH:mm') : value;
};

/** Relative hint such as "about 3 hours ago" (empty when no/invalid value). */
export const formatRelative = (value: string | null | undefined): string => {
    if (!value) return '';
    const date = toDate(value);
    return date ? formatDistanceToNow(date, { addSuffix: true }) : '';
};
